import { DrugClass } from "domain/entities/drug-class";
import { Result } from "domain/entities/result";
import { DrugClassRepository } from "domain/repositories";

export default class UpdateUseCase {
    private drugClassRepository: DrugClassRepository;
    
    public constructor(drugClassRepository: DrugClassRepository) {
        this.drugClassRepository = drugClassRepository
    }

    public async updateDrugClass(id: number, drug: DrugClass, token: Promise<[string | null, string | null]>): Promise<[Result, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.drugClassRepository.updateDrugClass(id, drug, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}